<script>
  import { intcomma } from 'journalize';
  /** @type {import('../types.d').ReadableRace} */
  export let race;
</script>

{#if $race.eevp != null}
  <p>{$race.eevp}% of expected vote in</p>
  <p>{intcomma($race.total_votes)} votes counted</p>
{:else}
  <p>{$race.precincts_reporting_percent}% of precincts reporting</p>
{/if}
